import React, { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import mountainImg from "../../assets/images/information/image5.png";
import mountainImg3 from "../../assets/images/information/image7.png";
import mountainImg2 from "../../assets/images/information/image6.png";
import mountainImg4 from "../../assets/images/information/image8.png";
import mountainImg6 from "../../assets/images/information/image10.png";
import backgroundImg from "../../assets/images/information/image6.jpg";
import iceTexture from "../../assets/images/information/image5.jpg";

const peaks = [
  {
    name: "Mount Everest",
    height: "8,848 m",
    image: mountainImg,
    expedition:
      "The highest mountain on Earth, Mount Everest dominates the Khumbu Himal of Nepal, drawing trekkers and climbers from around the world with its legendary presence and dramatic Himalayan landscapes.",
    details: [
      { label: "Price per person", value: "USD $2,500.00" },
      { label: "Country", value: "Nepal" },
      { label: "Route", value: "South Col (Standard)" },
      { label: "Range", value: "Khumbu Himalaya" },
      { label: "Best Season", value: "Spring / Autumn" },
    ],
  },
  {
    name: "K2",
    height: "8,611 m",
    image: mountainImg2,
    expedition:
      "Known as the Savage Mountain, K2 rises sharply from the Karakoram Range and is famed for its steep faces, extreme weather, and remote glacial terrain surrounding its legendary base camp.",
    details: [
      { label: "Price per person", value: "USD $2,500.00" },
      { label: "Country", value: "Pakistan" },
      { label: "Route", value: "Abruzzi Spur (via Skardu)" },
      { label: "Range", value: "Karakoram" },
      { label: "Best Season", value: "Summer" },
    ],
  },

  {
    name: "Kangchenjunga",
    height: "8,586 m",
    image: mountainImg3,
    expedition:
      "Remote approach with complex terrain and objective hazards. Logistics-heavy; good weather windows in spring and autumn.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },

  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],   // no PDF
  },
  {
    name: "Lhotse",
    height: "8,516 m",
    image: mountainImg4,
    expedition:
      "Shares sections with Everest (South Col) steep summit pyramid on the final push. Fast rotations and strong technical climbing needed.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],    // no PDF
  },
  {
    name: "Makalu",
    height: "8,485 m",
    image: mountainImg6,
    expedition:
      "Steep ridges and exposed climbing on the summit pyramid. Remote and less-frequented good for experienced technical alpinists.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],    // no PDF
  },
  {
    name: "Cho Oyu",
    height: "8,188 m",
    image: mountainImg,
    expedition:
      "Considered one of the more 'accessible' 8000m peaks less technical but still demands solid high-altitude experience and good acclimatisation.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],     // no PDF
  },
  {
    name: "Dhaulagiri I",
    height: "8,167 m",
    image: mountainImg2,
    expedition:
      "Big glaciated mountain with serious objective hazards (avalanches, seracs). Remote basecamp approaches and demanding weather.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],  },
  {
    name: "Manaslu",
    height: "8,163 m",
    image: mountainImg3,
    expedition:
      "Touring classic in Nepal long approach, mixed terrain. Requires acclimatisation and avalanche awareness in certain seasons.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],  },
  {
    name: "Nanga Parbat",
    height: "8,126 m",
    image: mountainImg4,
    expedition:
      "Extremely steep faces (Rupal face). Technical and serious limited rescue options. Best attempted by highly experienced teams.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],  },
  {
    name: "Annapurna I",
    height: "8,091 m",
    image: mountainImg6,
    expedition:
      "Infamous for objective hazards high avalanche risk. Requires careful route selection and conservative decision-making.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],  },
  {
    name: "Gasherbrum I",
    height: "8,080 m",
    image: mountainImg,
    expedition:
      "Also called Hidden Peak remote Karakoram expedition with mixed ice/rock routes. Strong logistics and acclimatisation required.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" },
  
],  },
  {
    name: "Broad Peak",
    height: "8,051 m",
    image: mountainImg2,
    expedition:
      "Long ridge-like summit with exposed snow/ice. Often climbed in conjunction with Gasherbrum peaks during Karakoram expeditions.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" }
],  },
  {
    name: "Gasherbrum II",
    height: "8,035 m",
    image: mountainImg3,
    expedition:
      "One of the more 'approachable' Karakoram 8000ers still remote and challenging with crevasse and serac objective hazards.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" }
],  },
  {
    name: "Shishapangma",
    height: "8,027 m",
    image: mountainImg4,
    expedition:
      "The only 8000er fully within Tibet. Shorter approach compared to Himalayan giants but still demands proper acclimatisation and alpine skills.",
  details: [
  { label: "Price per person", value: "USD $2,500.00" },
  { label: "Country", value: "Nepal" },
  { label: "Route", value: "Standard" },
  { label: "Range", value: "Khumbu Himal" },
  { label: "Best Season", value: "Spring/Autumn" }
],  },
];


const ExpeditionInfo = () => {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll();

  const totalPathLength = 3150;
  const visibleStart = 40;
  const animatedLength = totalPathLength - visibleStart;

  const pathLength = useTransform(scrollYProgress, [0, 1], [0, animatedLength / totalPathLength]);

  return (
    <div ref={containerRef} className="relative w-full bg-black text-white">
      {/* ICE TEXTURE BACKGROUND */}
      <div className="absolute top-0 left-0 w-full h-full z-0 overflow-hidden">
        <motion.div
          className="fixed top-0 left-0 w-full h-full pointer-events-none -z-10"
          style={{
            y: useTransform(scrollYProgress, [0, 1], [0, -80]),
          }}
        >
          <img
            src={backgroundImg}
            className="absolute top-0 left-0 w-full h-full object-cover opacity-30"
            alt="far mountains"
          />
        </motion.div>
      </div>

      {/* CURVED ICE LINE WITH GLOW */}
      <svg
        className="absolute top-0 left-0 w-full h-full pointer-events-none z-10"
        viewBox="0 0 100 3000"
        preserveAspectRatio="none"
      >
        <defs>
          <pattern id="icePattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
            <image href={iceTexture} x="0" y="0" width="100" height="100" />
          </pattern>
          <filter id="glow">
            <feGaussianBlur stdDeviation="0.6" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <motion.path
          d="
            M 50 0
            C 32 150, 68 300, 50 450
            C 28 600, 72 750, 50 900
            C 33 1050, 67 1200, 50 1350
            C 31 1500, 69 1650, 50 1800
            C 30 1950, 70 2100, 50 2250
            C 32 2400, 68 2550, 50 2700
            C 30 2850, 70 3000, 50 3150
          "
          fill="none"
          stroke="url(#icePattern)"
          strokeWidth="1.5"
          strokeLinecap="round"
          filter="url(#glow)"
          strokeDasharray={totalPathLength}
          style={{
            strokeDashoffset: useTransform(
              pathLength,
              (v) => totalPathLength - visibleStart - v * totalPathLength
            ),
          }}
        />
      </svg>

      {/* MAIN CONTENT */}
      <div className="flex flex-col relative z-20">
        {peaks.map((peak, index) => (
          <Section key={index} peak={peak} index={index} />
        ))}
      </div>
    </div>
  );
};

const Section = ({ peak, index }) => {
  const ref = useRef(null);
  const isEven = index % 2 === 0;

  const [openRoute, setOpenRoute] = useState(false);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 0.8", "start 0.2"],
  });

  const textOpacity = useTransform(scrollYProgress, [0, 1], [0, 1]);
  const imgOpacity = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <>
      {/* MAIN SECTION */}
      <div
        ref={ref}
        className={`grid grid-cols-1 md:grid-cols-2 items-center w-[90%] mx-auto my-auto mt-32 md:mt-0 lg:mt-10 min-h-screen`}
      >
        <motion.div
          style={{ opacity: textOpacity }}
          className={`${isEven ? "order-1 md:order-1 pr-10 z-10" : "order-1 md:order-2 pl-10 z-10"}`}
        >
          <h2 className="text-5xl font-bold">{peak.name}</h2>
          <p className="text-yellow-400 text-xl mb-4">{peak.height}</p>

          <p className="text-gray-300 mb-6">{peak.expedition}</p>

          <h3 className="text-lg font-semibold mb-2">Details:</h3>

          <motion.ul
            className="text-gray-300 mb-10 space-y-2"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              visible: { transition: { staggerChildren: 0.1 } },
            }}
          >
            {peak.details.map((item, i) => (
              <motion.li
                key={i}
                className="flex flex-wrap gap-2"
                variants={{
                  hidden: { opacity: 0, x: -20 },
                  visible: { opacity: 1, x: 0 },
                }}
              >
                <span className="font-semibold text-[#9bb7d4]">{item.label}:</span>
                <span>{item.value}</span>
              </motion.li>
            ))}
          </motion.ul>

          {/* BUTTONS */}
          <div className="flex gap-4 mt-6">
            {/* PDF Button */}
            {peak.pdf && (
              <a
                href={peak.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-white px-6 py-2 rounded-full hover:bg-white hover:text-black transition"
              >
                View Itinerary
              </a>
            )}
            
              <a
                href="/contact"
                className="inline-block border border-white px-6 py-2 rounded-full hover:bg-white hover:text-black transition"
              >
                Book Now
              </a>
          </div>
        </motion.div>

        <motion.div
          style={{
            opacity: imgOpacity,
            scale: useTransform(scrollYProgress, [0, 1], [0.6, 1]),
          }}
          className={`${isEven ? "order-2 md:order-2 z-20" : "order-2 md:order-1 z-20"}`}
        >
          <img
            src={peak.image}
            className="w-full h-[500px] object-contain shadow-xl"
            style={{
              maskImage: `url(${peak.image})`,
              WebkitMaskImage: `url(${peak.image})`,
              maskRepeat: "no-repeat",
              WebkitMaskRepeat: "no-repeat",
              maskSize: "contain",
              WebkitMaskSize: "contain",
              maskPosition: "center",
              WebkitMaskPosition: "center",
            }}
            alt={peak.name}
          />
        </motion.div>
      </div>
    </>
  );
};


export default ExpeditionInfo;
